import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,{attrs:{"align":"center"}},[_vm._l((_vm.links),function(link,i){return _c(VCol,{key:i,staticClass:"text-center",attrs:{"cols":"6","md":"auto"}},[_c('a',{staticClass:"text-decoration-none text-uppercase text-caption font-weight-regular",attrs:{"href":link.href,"rel":"noopener","target":"_blank"},domProps:{"textContent":_vm._s(link.text)}})])}),_c(VSpacer,{staticClass:"hidden-sm-and-down"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }